jQuery(document).ready(function ($) {
    // Perform AJAX login on form submit
    $("#login_modal_form").on("submit", function (e) {
        e.preventDefault();

        $("#login_modal .login_form_message").text("logging in ... ");
        var rememberVal = $("#login_modal_form #remember_me").is(":checked");
        var formData = {
            "action": "ajax_login", //calls wp_ajax_nopriv_ajax_login (functions.php)
            "username": $("#login_modal_form #login_username").val(),
            "password": $("#login_modal_form #login_password").val(),
            "remember": rememberVal,
            "relog" : $("#login_modal_form #relog").val(),
            "login_security": $("#login_modal_form #login_security").val()
        };

        $.ajax({
            type: "POST",
            url: ajax_object.ajax_url,
            data: formData,
            dataType: "json",
            success: function (data) {
                $("#login_modal .login_form_message").text(data.message);
                if (data.loggedin && $("#relog").val() == 1) {
                    $("#login_modal").modal("hide");
                    return;
                }
                if (data.loggedin){
                    document.location.href = data.redirecturl;
                    setTimeout(function () {
                        $("#login_modal").modal("toggle");
                    }, 1000);
                }
            }, 
            error : function(a, b, c){
                console.log(b, c);
            }
        });

    });

    $("#signup_modal_form").on("submit", function (e) {
        e.preventDefault();

        $("#signup_modal .signup_form_message").text("creating account ... ");

        if ($("#signup_modal_form #signup_password").val() != $("#signup_modal_form #signup_confirm_password").val()) {
            $("#signup_modal .signup_form_message").text("Your passwords don't match");
            return false;
        }

        $.ajax({
            type: "POST",
            dataType: "json",
            url: ajax_object.ajax_url,
            data: {
                "action": "ajax_create_user", //calls wp_ajax_nopriv_ajax_create_user
                "signup_username": $("#signup_modal_form #signup_username").val(),
                "signup_password": $("#signup_modal_form #signup_password").val(),
                "signup_confirm_password": $("#signup_modal_form #signup_confirm_password").val(),
                "signup_security": $("#signup_modal_form #signup_security").val()},
            success: function (data) {
                $("#signup_modal .signup_form_message").text(data.message);
                if (data.loggedin) {
                    document.location.href = data.redirecturl;
                }
            }
        });

    });

    var userRegion = "";
    var referral = "";
    var relativeUrl = window.location.pathname.replace(/\//g, '');
    if (relativeUrl == "educators"){
        referral = "logics";
        $.ajax({
            url: "https://ipinfo.io",
            dataType: "json",
            success: function(response) {
                userRegion = response.region;
            }
        });
    }

    $("#signup_modal_form_teacher").on("submit", function (e) {
        e.preventDefault();

        $("#signup_modal_teacher .signup_form_message").text("creating account ... ");

        if ($("#signup_modal_form_teacher #signup_password_teacher").val() != $("#signup_modal_form_teacher #signup_confirm_password_teacher").val()) {
            $("#signup_modal_teacher .signup_form_message").text("Your passwords don't match");
            return false;
        }

        $.ajax({
            type: "POST",
            dataType: "json",
            url: ajax_object.ajax_url,
            data: {
                "action": "ajax_create_teacher", //calls wp_ajax_nopriv_ajax_create_teacher
                "signup_username": $("#signup_modal_form_teacher #signup_username_teacher").val(),
                "signup_school_name": $("#signup_modal_form_teacher #signup_school_name").val(),
                "signup_password": $("#signup_modal_form_teacher #signup_password_teacher").val(),
                "signup_confirm_password": $("#signup_modal_form_teacher #signup_confirm_password_teacher").val(),
                "signup_security": $("#signup_modal_form_teacher #signup_security_teacher").val(),
                "signup_referral": referral,
                "signup_region": userRegion
            },
            success: function (data) {
                $("#signup_modal_teacher .signup_form_message").text(data.message);
                if (data.loggedin) {
                    document.location.href = data.redirecturl;
                }
            }
        });

    });

    $(".pixelpad_login, #pixelpad_login").on("click", function (e) {
        e.preventDefault();
        $("#login_modal").modal("show");
    });

});

